import React from 'react';
export function StorySection() {
  return <section className="py-16 md:py-24 px-4 bg-white relative" data-id="element-490">
      <div className="max-w-3xl mx-auto" data-id="element-491">
        <div className="prose prose-lg md:prose-xl prose-p:text-dark/80 prose-p:leading-relaxed mx-auto" data-id="element-492">
          <div className="not-prose mb-10" data-id="element-493">
            <div className="w-16 h-1 bg-gold rounded-full mb-5" data-id="element-494" />
            <h2 className="font-serif text-3xl md:text-5xl font-bold leading-tight text-forest text-balance" data-id="element-495">
              Estoy segura de que reconocés esta secuencia porque la vivís{' '}
              <span className="text-gold-dark" data-id="element-496">cada 24 horas.</span>
            </h2>
          </div>

          <div className="not-prose mb-10 pl-4 border-l-4 border-gold" data-id="element-497">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-gold-dark mb-2" data-id="element-498">
              Cuando llegás a casa
            </p>
            <p className="text-xl md:text-2xl font-serif font-bold text-forest m-0" data-id="element-499">
              Son las 8 de la noche.
            </p>
          </div>

          <p data-id="element-500">
            Llegás a casa, dejás las llaves y sentís que tu cuerpo finalmente
            &quot;se suelta&quot;. Pero no de la forma que te gustaría.
          </p>

          <p data-id="element-501">
            Cruzás la puerta de tu casa arrastrando el cansancio de un día
            interminable. Tu espalda pesa, pero tu vientre pesa más. Sentís esa
            presión incómoda en el botón del jean, esa que ya no podés ignorar
            ni metiendo panza.
          </p>

          <p data-id="element-502">
            Te mirás de reojo en el espejo del pasillo bajo esa luz dicroica que
            no perdona. Y ahí está. Ese abdomen que por la mañana estaba
            &quot;bajo control&quot;, ahora tiene vida propia.
          </p>

          <p className="not-prose font-serif text-2xl md:text-3xl font-bold text-forest my-8 text-center" data-id="element-503">
            Parece el cuerpo de otra persona.
          </p>

          <p data-id="element-504">
            No es grasa, es una tensión dura, inflamada, que te hace sentir
            pesada incluso antes de cenar.
          </p>

          <p data-id="element-505">Apretás los labios. Suspirás. Y te decís la mentira de siempre:</p>

          <p className="italic font-medium text-forest text-xl md:text-2xl my-8 text-center" data-id="element-506">
            &quot;Mañana arranco en serio&quot;.
          </p>

          <div className="not-prose my-10 py-5 border-y border-forest/10" data-id="element-507">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-gold-dark mb-2" data-id="element-508">
              La cena “liviana”
            </p>
            <p className="text-xl md:text-2xl font-serif font-bold text-forest m-0" data-id="element-509">
              Querés hacer todo bien. O eso creés.
            </p>
          </div>

          <p data-id="element-510">
            Vas a la cocina convencida de que vas a &quot;portarte bien&quot;.
            Buscás algo &quot;liviano&quot;, algo que no te dé culpa: una
            ensalada de lechuga y tomate, un yogurt firme o esa rodaja de pan
            integral que te dijeron que era la salvación.
          </p>

          <p className="font-bold text-dark text-xl" data-id="element-511">
            Cenás con responsabilidad... o eso creés.
          </p>

          <p data-id="element-512">
            Te vas a la cama, pero tu cuerpo no descansa. Tu sueño es liviano,
            como si estuvieras alerta. Te despertás a las 3 AM con sed o
            simplemente sin razón.
          </p>

          <div className="not-prose my-10 bg-cream p-5 md:p-6 rounded-xl border border-forest/10" data-id="element-513">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-gold-dark mb-2" data-id="element-514">
              A la mañana siguiente
            </p>
            <p className="text-xl md:text-2xl font-serif font-bold text-forest m-0" data-id="element-515">
              El cansancio vuelve antes de que empiece el día.
            </p>
          </div>

          <p data-id="element-516">
            A las 7 AM suena el despertador y la sensación es demoledora: te
            sentís más cansada que cuando te acostaste.
          </p>

          <p data-id="element-517">
            Caminás descalza hasta el baño y lo primero que ves... es ese espejo
            de nuevo. Amanecés como un globo, con la cara pesada y la misma
            frustración que ayer.
          </p>

          <p className="not-prose text-xl md:text-2xl font-bold text-forest leading-relaxed mt-10" data-id="element-518">
            ¿Por qué, si cenaste &quot;sano&quot;, tu cuerpo te devuelve esta
            imagen?
          </p>

          <p data-id="element-519">
            Porque mientras dormías, esa cena &quot;liviana&quot; se convirtió
            en un campo de batalla para tu sistema digestivo.
          </p>
        </div>

        {/* Empathy Callout */}
        <div className="mt-12 p-6 md:p-8 bg-cream-dark/50 border-l-4 border-gold rounded-r-xl shadow-sm" data-id="element-520">
          <p className="text-lg md:text-xl font-medium text-dark mb-4" data-id="element-521">
            💬 Si esto te suena familiar, no es tu culpa. Y no es falta de
            voluntad.
          </p>
          <p className="text-lg md:text-xl font-bold text-forest" data-id="element-522">
            Es que nadie te explicó lo que realmente le pasa a tu cuerpo después
            de los 35.
          </p>
        </div>
      </div>
    </section>;
}